// eslint-disable-next-line max-len
export const getCheckedFilterOnItems = (state) =>
  state.itemCriteriaSelector.itemCriteria.checkedFilterOnItems;

// eslint-disable-next-line max-len
export const getCheckedOnlyShowItems = (state) =>
  state.itemCriteriaSelector.itemCriteria.checkedOnlyShowItems;

// eslint-disable-next-line max-len
export const getCheckedOnlyShowItemsWith = (state) =>
  state.itemCriteriaSelector.itemCriteria.checkedOnlyShowItemsWith;

// eslint-disable-next-line max-len
export const getCheckedFilterOnImpc = (state) =>
  state.itemCriteriaSelector.itemCriteria.checkedFilterOnImpc;

// eslint-disable-next-line max-len
export const getCheckedFilterOnDespatch = (state) =>
  state.itemCriteriaSelector.itemCriteria.checkedFilterOnDespatch;

// eslint-disable-next-line max-len
export const getManualEntryText = (state) =>
  state.itemCriteriaSelector.itemCriteria.manualEntryText;

// eslint-disable-next-line max-len
export const getSpaceSeparatedSuffixes = (state) =>
  state.itemCriteriaSelector.itemCriteria.spaceSeparatedSuffixes;
